import { load } from 'poly-eshop4/eshop/ui/js/util';

$(document).on('click', '[data-filterlist-cart]', function() {
  const $this = $(this);
  $this.addClass('loading');
});

$(document).on('change', '[data-filterlist-positions-ordering]', function(event) {
  event.preventDefault();
  $(this).submit();
});

$(document).on('change', '[data-filterlist-position-quantity]', function() {
  const qty = $(this).val();
  $(this).closest('[data-cart-item]').find('input[name="quantity"]').each((idx, input) => {
    input.value = qty;
  });
});

$(document).on('submit', '[data-add-to-shopping-list-from-filterlist]', function(event) {
  event.preventDefault();
  const qty = $(this).find('input[name="quantity"]').val();
  $.ajax({
    method: 'POST',
    url: $(this).attr('action'),
    data: $(this).serialize(),
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.find('input[name="quantity"]').each((idx, input) => {
      if (!input.value) {
        input.value = qty;
      }
    });
    element.foundation().foundation('open');
  });
});

$(document).on('submit', '[data-add-to-cart-from-filterlist]', function (event) {
  event.preventDefault();
  const $form = $(this);
  const data = $form.serializeArray();

  if ($form.attr('data-add-to-cart') === 'editmode') {
    $('[data-container-position-editmode]:checked').each((idx, input) => {
      data.push({ name: 'position_id', value: input.value });
    });
  }

  const qty = $(this).find('input[name="quantity"]').val();

  $.ajax({
    method: 'POST',
    url: $(this).attr('action'),
    data,
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.find('input[name="quantity"]').each((idx, input) => {
      if (!input.value) {
        input.value = qty;
      }
    });
    element.foundation().foundation('open');
  });
});

$(document).on('submit.addCartPositions', '[data-add-cart-positions-from-filterlist]', function(event) {
  event.preventDefault();

  const $form = $(this).closest('form');
  const data = $form.serializeArray();

  $('[data-cart-item]:not(".hide") [data-filterlist-position-quantity]').each((idx, input) => {
    data.push({ name: 'position_id', value: input.getAttribute('data-filterlist-position-quantity') });
    data.push({ name: 'quantity', value: input.value });
  });

  load(
    this,
    $.stores.cart.post($form.attr('action'), data),
  );
});

$(document).on('submit', '[data-add-positions-to-shopping-list-from-filterlist]', function (event) {
  event.preventDefault();

  const $form = $(this).closest('form');
  const data = $form.serializeArray();

  $('[data-cart-item]:not(".hide") [data-filterlist-position-quantity]').each((idx, input) => {
    data.push({ name: 'position_id', value: input.getAttribute('data-filterlist-position-quantity') });
    // data.push({ name: 'quantity', value: input.value });
  });

  $.ajax({
    method: 'POST',
    url: $(this).attr('action'),
    data,
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});

$(document).on('keyup', '[data-search-filterlist]', window.Foundation.util.debounce(function _() {
  const $this = $(this);
  const $wrapper = $('.itemlist__items-wrapper');
  const query = $this.val();
  const searchQuery = query.toLowerCase();

  if (query.length === 0) {
    $wrapper
      .find('> [data-cart-item]').removeClass('hide');
    return;
  }

  $wrapper.find('> [data-cart-item]').each((rowCounter, item) => {
    const $item = $(item);
    let hit = false;

    $item.find('*').each((colCounter, elem) => {
      const $elem = $(elem);
      const containsQuery = $elem.text().toLowerCase().indexOf(searchQuery) > -1;

      if (containsQuery) {
        hit = true;
      }
    });

    $item.toggleClass('hide', !hit);
  });
}, 150));
